/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import DefaultPage from '../DefaultPage'
import OutllineButton from '../../../components/buttons/OutllineButton'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useLocation } from 'react-router'
import { AppStyles } from '../../../assets/styles/AppStyles'
import { useTheme } from '../../../utils/ThemeColorContext'
import Modal from '../../../components/Modal'
import { useState } from 'react'
import { InfoIcon } from '../../../assets/AppIcons'
import CustomOTPInput from '../../../components/CustomOtp'
import PrimaryButton from '../../../components/buttons/PrimaryButton'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { Auth } from 'aws-amplify'
import { getApplications, getProfile } from '../../../redux/Actions/getMethods'
import EmailIcon from '../../../assets/icons/Email.svg'
import PhoneIcon from '../../../assets/icons/phoneIcon.svg'
import { isSafari } from '../../../utils/browser'
import SpinnerLarge from '../../../components/SpinnerLarge'
import { ActionTypes } from '../../../redux/Constants/actionTypes'
import { removeAllGarbage } from '../../../api/dummyData'
import OnEnter from '../../../components/navigation/onEnter'
import captureException from '../../../utils/SentryHelper'
import TagManager from 'react-gtm-module'

function ConfirmPhone() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { token } = useSelector((state) => state.authReducer)
  const { loadingWholeScreen, getApplication } = useSelector(
    (state) => state.dataReducer,
  )
  const [err, setErr] = useState('')
  const [limitErr, setLimitErr] = useState('')
  const [searchParams] = useSearchParams()

  const { color, isSmallScreen } = useTheme()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [otp, setOtp] = useState(new Array(6).fill(''))
  const isValidCode =
    otp.join('').length > 5 && otp.join('') === '000000' ? true : false

  const location = useLocation()

  const sendVerificationCode = async () => {
    const user = await Auth.currentAuthenticatedUser()
    const attribute = 'phone_number'
    try {
      const result = await Auth.verifyUserAttribute(user, attribute, {
        platform: 'web',
      })
      return result
    } catch (error) {
      captureException(error)
      console.error('Error sending verification code:', error)
      if (
        error?.message === 'Attempt limit exceeded, please try after some time.'
      ) {
        setLimitErr(error?.message)
        setTimeout(() => {
          setLimitErr('')
        }, 5000)
      } /* else if (error?.message === "") {
        here;
      } */
    }
  }

  useEffect(() => {
    if (setOtp(new Array(6).fill(''))) {
      setErr(false)
    }
    if (searchParams.get('code')) {
      confirmAttributeVerificationss(searchParams.get('code'))
    } else if (token?.phone_number_verified !== true) {
      sendVerificationCode()
    } else {
      navigate('/signagreement')
    }
  }, [searchParams.get('code')])

  const confirmAttributeVerificationss = async (otp) => {
    try {
      const confirmationResult = await Auth.verifyCurrentUserAttributeSubmit(
        'phone_number',
        otp,
        {
          platform: 'web',
        },
      )
      if (confirmationResult) {
        const profile = await dispatch(getProfile())
        if (profile) {
          setIsModalOpen(false)
          navigate('/phone-verified')
        }
      }
      return confirmationResult
    } catch (error) {
      captureException(error)
      if (
        error?.message ===
        'Invalid verification code provided, please try again.'
      ) {
        setErr(true)
        setOtp(new Array(6).fill(''))
        setTimeout(() => {}, 5000)
      }
    }
  }

  // ==================== Checking user status  =======================//
  useEffect(() => {
    if (!getApplication[0]?.id) {
      const temp = async () => {
        dispatch({ type: ActionTypes.LOADING_SUCCESS_WHOLE_SCREEN })
        const myID = await dispatch(getApplications())
        if (searchParams.get('code')?.length > 0) {
          console.log('')
        } else if (
          myID?.data[0]?.status === 'APPROVED' &&
          myID?.data[0]?.dd_account_number
        ) {
          dispatch({ type: ActionTypes.LOADING_FAIL_WHOLE_SCREEN })
          removeAllGarbage()
        } else {
          dispatch({ type: ActionTypes.LOADING_FAIL_WHOLE_SCREEN })
          navigate('/address-detail')
        }
      }
      temp()
    }
  }, [!getApplication[0]?.id])

  return (
    <DefaultPage>
      {loadingWholeScreen ? (
        <SpinnerLarge />
      ) : (
        <>
          <div className=" relative container mx-auto md:w-[564px]   space-y-10 h-800 py-8 md:py-0 ">
            <div
              className={`bg-white px-6 py-10 md:p-10  flex flex-col items-center justify-center space-y-6 md:w-[564px]
              }rounded-[24px]`}
            >
              <img src={EmailIcon} />
              <div className=" flex flex-col items-center space-y-4">
                <h1
                  style={
                    isSmallScreen
                      ? {
                          ...AppStyles.LargeTitle5,
                          color: color.Plum,
                        }
                      : {
                          ...AppStyles.LargeTitle2,
                          color: color.Plum,
                        }
                  }
                  className=" text-center"
                >
                  Check Your Phone
                </h1>
                <p
                  style={
                    isSmallScreen
                      ? {
                          ...AppStyles.Body14,
                          color: color.Grey,
                        }
                      : {
                          ...AppStyles.Body14,
                          color: color.Grey,
                        }
                  }
                  className=" text-center"
                >
                  To verify your identity we've sent a text to
                </p>
                <h3
                  style={{
                    ...AppStyles.Title2,
                    color: color.BlurpleTeal,
                  }}
                  className=" text-center"
                >
                  {token?.phone_number}
                </h3>
              </div>

              <div
                style={{
                  backgroundColor: color.White,
                  borderColor: color.MidGrey,
                  margin: '24px 0',
                }}
                className="p-4 border w-full flex rounded-2xl space-x-4  items-start justify-start"
              >
                <div>
                  <InfoIcon fill={color.BlurpleTeal} />
                </div>
                <p
                  style={{
                    ...AppStyles.Body12Demi2_1,
                    color: color.Grey,
                    lineHeight: '20px',
                    ...(isSafari
                      ? {
                          fontFamily: 'MaisonDemiBold',
                          fontWeight: '500',
                        }
                      : {}),
                  }}
                >
                  Once opened, please look for the code provided and enter it
                  below.
                </p>
              </div>

              <div
                style={{ margin: 0 }}
                className="flex flex-col items-center space-y-2 w-full"
              >
                <div className={'w-full space-y-4'}>
                  <div
                    className=" flex flex-col space-y-6"
                    style={{}}
                  >
                    <div className="w-full max-w-[440px] mx-auto">
                      <CustomOTPInput
                        otp={otp}
                        setOtp={setOtp}
                        isValidCode={err}
                        setErr={setErr}
                      />
                    </div>
                  </div>
                  <div className="space-y-6">
                    <p></p>
                  </div>
                {err && (
                  <p
                    style={{ ...AppStyles.Caption1, color: color.SoftPink }}
                    className=" text-center "
                  >
                    We couldn’t validate your code.
                  </p>
                )}
                </div>
                <div className={'w-full space-y-2'}>
                  <PrimaryButton
                    id={'confirm-verification-btn'}
                    disabled={!otp?.every((char) => char !== '') || isValidCode}
                    className={'w-full'}
                    text={'Submit'}
                    onClick={async () => {
                      await confirmAttributeVerificationss(otp.join(''))
                    }}
                  />
                </div>
                {limitErr && (
                  <p
                    style={{ ...AppStyles.Caption1, color: color.SoftPink }}
                    className=" text-center "
                  >
                    {limitErr}
                  </p>
                )}
                {/* <p onClick={() => setIsModalOpen(true)}>
              <a
                style={{ ...AppStyles.BodyLink, color: color.BlurpleWhite }}
                className="underline cursor-pointer"
              >
                Enter Code
              </a>
            </p> */}
              </div>
            </div>
          </div>
          <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
            <div className=" space-y-6">
              <div
                className=" w-full flex flex-col items-center justify-center space-y-6 "
                style={{}}
              >
                <div className="flex w-fit relative items-center justify-center">
                  {/* <Iphone fill={color.BlurpleTeal} /> */}
                  <img src={PhoneIcon} />
                  <div
                    style={{ backgroundColor: color.Teal }}
                    className=" absolute top-[0px] right-[5px] rounded-md transform rotate-45 flex items-center justify-center  w-[24px] h-[24px] "
                  >
                    <p className="transform -rotate-45  text-white text-12 font-bold font-maisonBold w-full text-center">
                      1
                    </p>
                  </div>
                </div>
                <div className="flex flex-col items-center">
                  <p style={{ ...AppStyles.Title1, color: color.Plum }}>
                    Please enter your code
                  </p>
                  <p style={{ ...AppStyles.Subheading1, color: color.Grey }}>
                    You'll find it in the text we sent
                  </p>
                </div>
              </div>
              <CustomOTPInput
                otp={otp}
                setOtp={setOtp}
                isValidCode={err}
                setErr={setErr}
              />
              {err && (
                <p
                  style={{ ...AppStyles.Caption1, color: color.SoftPink }}
                  className=" text-center "
                >
                  We couldn’t validate your code
                </p>
              )}

              <div className=" space-y-2">
                <OutllineButton
                  id={'cancel-text'}
                  text={'Cancel'}
                  onClick={() => {
                    setOtp(new Array(6).fill(''))
                    setIsModalOpen(false)
                  }}
                />
                <OnEnter
                  actionFunction={async () => {
                    if (!otp?.every((char) => char !== '') || isValidCode) {
                      return
                    }
                    const tagManagerArgs = {
                      dataLayer: {
                        event: 'onenter-confirm-phone-submit',
                        page: location?.pathname,
                      }
                    }
                    TagManager.dataLayer(tagManagerArgs)
                    await confirmAttributeVerificationss(otp.join(''))
                  }}
                />
                <PrimaryButton
                  id={'confirm-phone-verification-btn'}
                  disabled={!otp?.every((char) => char !== '') || isValidCode}
                  className={'w-full'}
                  text={'Submit'}
                  onClick={async () => {
                    await confirmAttributeVerificationss(otp.join(''))
                  }}
                />
              </div>
            </div>
          </Modal>
        </>
      )}
    </DefaultPage>
  )
}

export default ConfirmPhone
